<template>
    <div>
        <PageHeader>
            {{ $t('offersModeration') }}
        </PageHeader>
        <Filters ref="Filters" />
        <Results ref="Results" />
    </div>
</template>



<script>
    import viewFiltersMixin from '@/mixins/viewFiltersMixin';
    import Filters from './parts/Filters.vue';
    import Results from './parts/Results.vue';

    const DEFAULT_FILTERS_PARAMS = Object.freeze({
        id: null,
        offerId: null,
        ean: null,
        name: null,
        info: null,
        feed: null,
        campaignId: null,
        productId: null,
        riskScoreFrom: null,
        riskScoreTo: null,
        offerRiskScoresFrom: {
            info_similarity: null,
            name_similarity: null,
            offer_quantity: null,
        },
        offerRiskScoresTo: {
            info_similarity: null,
            name_similarity: null,
            offer_quantity: null,
        },
        productRiskScoresFrom: {
            existing_variant: null,
            info_similarity: null,
            name_similarity: null,
        },
        productRiskScoresTo: {
            existing_variant: null,
            info_similarity: null,
            name_similarity: null,
        },
    });
    const DEFAULT_TABLE_PARAMS = Object.freeze({
        perPage: 25,
        page: 1,
        sort: 'id',
        order: 'DESC',
    });

    export default {
        name: 'OffersModeration',
        mixins: [viewFiltersMixin],
        components: {
            Filters,
            Results,
        },
        provide() {
            return {
                parentComponent: this,
            };
        },
        data() {
            return {
                ...this.initParams(DEFAULT_FILTERS_PARAMS, DEFAULT_TABLE_PARAMS),
                request: this.$req('offers/moderation'),
            };
        },
        computed: {
            requestParams() {
                return {
                    page: this.tableParams.page,
                    perPage: this.tableParams.perPage,
                    sort: this.tableParams.sort,
                    order: this.tableParams.order,
                    ...this.requestParamsFilters,
                };
            },
        },
    };
</script>
